<div class="row">
  <div class="col-4">
    <div class="card">
      <div class="card-header">
        Package Information
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-4"><label>Tracking #:</label></div>
          <div class="col-8">{{package.TrackingNumber}} <span [hidden]="package?.ShipmentType==null">({{package.ShipmentType}})</span></div>
        </div>
        <div class="row">
          <div class="col-4"><label>From:</label></div>
          <div class="col-8">
            {{package.FromName}}<br />
            {{package.FromAddress1}}<br />
            {{package.FromCity}} {{package.FromState}} {{package.FromZipCode}}
          </div>
        </div>
        <div class="row" [hidden]="package?.FromPhone == null">
          <div class="col-4"><label>Shipper Phone:</label></div>
          <div class="col-8">{{package.FromPhone}}</div>
        </div>
        <div class="row" [hidden]="!package.ClientId">
          <div class="col-4"><label>Client:</label></div>
          <div class="col-8">
            {{package.ClientName}}<br />
            {{package.ClientAddress1}}<br />
            {{package.ClientCity}} {{package.ClientState}} {{package.ClientZipCode}}
          </div>
        </div>
        <div class="row">
          <div class="col-12" [hidden]="!package.ResolveTeamAssignedTo">
            Resolve Team Assigned To {{package.ResolveTeamAssignedTo}} on {{package.ResolveTeamAssignedDate | date:'short'}} by {{package.ResolveTeamAssignedBy}}
          </div>
          <div class="col-12" *hasClaim="'Package_Assign_User'" [hidden]="!reqCountException">
            Resolve Team Assigned To: <p-select [options]="resolveUsers" [(ngModel)]="package.ResolveTeamAssignedTo" (onChange)="resolveTeamAssignedToOnChange()" [style]="{'width':'60%'}"></p-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-4">

    <div class="card">
      <div class="card-header">
        Package Timeline
        <span class="float-right">
          <a [hidden]="package?.CompletedDate==null" *hasClaim="'Package_Edit'" (click)="reopenPackage()" class="iconbutton" title="Reopen Package"><i class="fal fa-folder-open"></i></a>
        </span>
      </div>
      <div class="card-body">
        <div class="row" [hidden]="package?.PackageEscalations==null">
          <div class="col-12" *ngFor="let escalation of package.PackageEscalations">
            <span [ngClass]="{'text-danger': !escalation.Resolved}">{{escalation.IssueDescription}}</span> <span *ngIf="escalation.Resolved">(Resolved)</span>
          </div>
        </div>
        <div class="row" [hidden]="package?.DeliveredDate==null">
          <div class="col-12">
            Delivered on {{package.DeliveredDate | date:'short'}}
          </div>
        </div>
        <div class="row" [hidden]="package?.ReceivedDate==null">
          <div class="col-12">
            Received on {{package.ReceivedDate | date:'short'}} by {{package.ReceivedBy}}
          </div>
        </div>
        <div class="row" [hidden]="package?.OpenedDate==null">
          <div class="col-12">
            Opened on {{package.OpenedDate | date:'short'}} by {{package.OpenedBy}}
          </div>
        </div>
        <div class="row" [hidden]="package?.CompletedDate==null">
          <div class="col-12">
            Completed on {{package.CompletedDate | date:'short'}} by {{package.CompletedBy}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-4">

    <div class="card">
      <div class="card-header">
        Package Contents
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            {{reqCount}} samples
            <span class="float-right">
              <a [hidden]="!reqCount" (click)="copyToClipBoard('A')" class="iconbutton" title="Copy all samples to clipboard"><i class="fal fa-clipboard-list"></i></a>
            </span>
          </div>
        </div>
        <div class="row" [hidden]="reqCountException == 0">
          <div class="col-12">
            {{reqCountException}} samples with exceptions
            <div class="float-right">
              <a *hasClaim="'Resolve_Edit'" [hidden]="!reqCountException || processingExceptions " (click)="attemptToResolveRequisitionExceptions()" class="iconbutton" title="Resolve Exceptions"><i class="fal fa-laptop-medical"></i> </a>
              <span [hidden]="!processingExceptions" class="iconbutton"><i class="fas fa-spinner fa-pulse"></i></span>
              <a [hidden]="!reqCountException" (click)="copyToClipBoard('E')" class="iconbutton" title="Copy exceptions to clipboard"><i class="fal fa-clipboard-list"></i></a>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="reqCountRejected == 0">
          <div class="col-12">
            {{reqCountRejected}} samples that were rejected
            <span class="float-right">
              <a [hidden]="!reqCountRejected" (click)="copyToClipBoard('R')" class="iconbutton" title="Copy rejects to clipboard"><i class="fal fa-clipboard-list"></i></a>
            </span>
          </div>
        </div>
      </div>

    </div>
    <!--<div class="row">
      <div class="col-12">
        <a class="pull-right mr-4 mt-3" style="font-size:24px"><i class="fa fa-envelope-open fa-th-large"></i></a>
      </div>
    </div>-->
  </div>
</div>
<div class="mt-4">
  <p-accordion value="">
    <p-accordion-panel *ngFor="let req of requisitions" [selected]="req.Accession == searchTerm" [value]="req.Id">
      <p-accordion-header>
        <div>
          <span class="mr-2" style="font-size:1.2em" *ngIf="req.StatusLevel == 3" title="Rejected"><i style="--fa-primary-color: white; --fa-secondary-color: red; --fa-secondary-opacity: 1.0;" class="fad fa-copy"></i></span>
          <span class="mr-2" style="font-size:1.2em" *ngIf="req.StatusLevel == 2" title="Exceptions"><i style="--fa-primary-color: white; --fa-secondary-color: yellow; --fa-secondary-opacity: 1.0;" class="fad fa-copy"></i></span>
          <span class="mr-2" style="font-size:1.2em" *ngIf="req.StatusLevel == 1" title="Accepted"><i style="--fa-primary-color: white; --fa-secondary-color: green; --fa-secondary-opacity: 1.0;" class="fad fa-copy"></i></span>
          <span class="mr-4">{{req.Accession}}</span>
          <span class="mr-4">{{req.FirstName}} {{req.LastName}}</span>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <app-receiving-sample requisitionId="{{req.Id}}" (onSampleUpdated)="updateSample($event)" packageDeliveredDate="{{package.DeliveredDate}}"></app-receiving-sample>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
<p-toast>
</p-toast>
